import { UpperCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DOCUMENT,
  HostListener,
  inject,
  signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { LanguageRepository, ThemeBaseComponent } from 'src/app/_core';
import { IconComponent } from '../../../icon/icon.component';
import { TranslateModule } from '@ngx-translate/core';
import { tap } from 'rxjs';

@Component({
  standalone: true,
  selector: 'neopos-lang-selector',
  templateUrl: './lang-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UpperCasePipe, IconComponent, TranslateModule],
})
export class LangSelectorComponent extends ThemeBaseComponent {
  private readonly _languageRepository = inject(LanguageRepository);
  private readonly _document = inject(DOCUMENT);

  availableLangs = toSignal(this._languageRepository.availableLangs$);

  currentLang = toSignal(
    this._languageRepository.lang$.pipe(
      tap(
        (res) =>
          this._document.documentElement.lang !== res &&
          (this._document.documentElement.lang = res)
      )
    )
  );

  showDropdown = signal<boolean>(false);

  onChangeLanguage(lang: string): void {
    this._languageRepository.setLang(lang);

    this.showDropdown.set(false);
  }

  @HostListener('window:click', ['$event'])
  handleClick() {
    this.showDropdown.set(false);
  }
}
